export * from './lib/shared-ui-modal.module';
export * from './lib/deprecated-modal/deprecated-modal.component';
export * from './lib/base-modal/base-modal.component';
